import React, { useState, useEffect } from "react";
import {
  Container,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
} from "@mui/material";
import { fetchJsonDynamic } from "../../../data/DynamicServiceNew/jsondynamicservice";
import { loanManagementUrl } from "../../../config";
const GroupLoanSchedule = () => {
  const [loanId, setLoanId] = useState(null);
  const [loanData, setLoanData] = useState(null);
  //   const [loanedId, setLoanedId] = useState("");
  const [loanDetails, setLoanDetails] = useState(null);
  const [loanSchedule, setLoanSchedule] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const formatDate = (date) => {
    if (!date) return "-";
    const d = new Date(date);
    return d.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };
  const formattedAmount = (amount) => {
    if (isNaN(amount) || amount === undefined || amount === null) return "0.0";
    return amount.toLocaleString("en-US", { minimumFractionDigits: 2 });
  };

  useEffect(() => {
    if (!loanId) {
      setLoanDetails(null);
      setLoanSchedule([]);
      return;
    }

    const delayDebounce = setTimeout(() => {
      fetchLoanData(loanId);
    }, 500); // 500ms delay before calling API

    return () => clearTimeout(delayDebounce); // Cleanup timeout on each change
  }, [loanId]);

  const fetchLoanData = async (id) => {
    setLoading(true);
    setError(null);

    try {
      const response = await fetchJsonDynamic(
        "allGroupLoanSchedulesByLoanId",
        "parameters",
        { loanId: parseInt(id) },
        loanManagementUrl.uri
      );

      const data = JSON.parse(response.results);

      if (!data.LoanSchedules || data.LoanSchedules.length === 0) {
        setError("No Loan Schedule found for the given loan.");
        setLoanDetails(null);
        setLoanSchedule([]);
        return;
      }

      setLoanDetails(data.LoanApplications[0]);
      setLoanSchedule(data.LoanSchedules);
    } catch (err) {
      setError("An error occurred while fetching loan schedule data.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <Typography variant="h5" gutterBottom>
        Group Loans Schedule
      </Typography>
      <TextField
        label="Loan ID"
        variant="outlined"
        fullWidth
        value={loanId}
        onChange={(e) => setLoanId(e.target.value)}
        margin="normal"
      />
      {loading && <Typography>Loading...</Typography>}
      {error && <Typography color="error">{error}</Typography>}

      {loanSchedule && loanDetails && (
        <Box>
          <Typography variant="h5" gutterBottom>
            <strong>Loan Details</strong>
          </Typography>
          <TableContainer component={Paper}>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                    <strong>Loan Ref:</strong>
                  </TableCell>
                  <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                    {loanDetails.id}
                  </TableCell>
                  <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                    <strong>Borrow Date:</strong>
                  </TableCell>
                  <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                    {formatDate(loanDetails.applicationdate)}
                  </TableCell>
                  <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                    <strong>Expected Clear Date:</strong>
                  </TableCell>
                  <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                    {formatDate(loanDetails.expectedcleardate)}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                    <strong>Loan Amount:</strong>
                  </TableCell>
                  <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                    {formattedAmount(loanDetails.loanamount) ?? 0.0}
                  </TableCell>
                  <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                    <strong>Amount Disbursed:</strong>
                  </TableCell>
                  <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                    {formattedAmount(loanDetails.amounttodisburse) ?? 0.0}
                  </TableCell>
                  <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                    <strong>Loan Balance:</strong>
                  </TableCell>
                  <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                    {formattedAmount(loanDetails.loanbalance) ?? 0.0}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                    <strong>Principal Amount:</strong>
                  </TableCell>
                  <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                    {formattedAmount(loanDetails.amounttodisburse) ?? 0.0}
                  </TableCell>
                  <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                    <strong>Interest Amount:</strong>
                  </TableCell>
                  <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                    {formattedAmount(loanDetails.interestamount) ?? 0.0}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
          <Typography sx={{
            marginTop:"20px"
          }} variant="h5" gutterBottom>
            <strong>Loan Schedule </strong>
          </Typography>
          <TableContainer component={Paper} sx={{ border: "1px solid #ddd" }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                    <strong>#</strong>
                  </TableCell>
                  <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                    {" "}
                    <strong>Installment Amount</strong>
                  </TableCell>
                  <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                    {" "}
                    <strong>Due Date</strong>
                  </TableCell>
                  <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                    {" "}
                    <strong></strong>
                  </TableCell>
                  <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                    <strong>To pay</strong>
                  </TableCell>
                  <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                    <strong>Paid</strong>
                  </TableCell>
                  <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                    <strong>Unpaid</strong>
                  </TableCell>
                  <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                    <strong>status</strong>
                  </TableCell>

                  <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                    <strong>Overpayment</strong>
                  </TableCell>
                  <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                    <strong>Payment Date</strong>
                  </TableCell>
                  {/* <TableCell sx={{ borderRight: "1px solid #ddd" }}><strong>Arrears</strong></TableCell> */}
                  <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                    <strong>Status</strong>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loanSchedule?.map((row, index) => (
                  <>
                    {/* First row for installment details */}
                    <TableRow
                      key={`installment-${index}`}
                      sx={{ borderBottom: "1px solid #ddd" }}
                    >
                      <TableCell
                        sx={{ borderRight: "1px solid #ddd" }}
                        rowSpan={3}
                      >
                        {index + 1}
                      </TableCell>
                      <TableCell
                        sx={{ borderRight: "1px solid #ddd" }}
                        rowSpan={3}
                      >
                        {formattedAmount(row.AmountToPay) ?? 0.0}
                      </TableCell>
                      <TableCell
                        sx={{ borderRight: "1px solid #ddd" }}
                        rowSpan={3}
                      >
                        {formatDate(row.ExpectedDueDate)}
                      </TableCell>
                      <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                        Principal
                      </TableCell>
                      <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                        {formattedAmount(row.OriginalPrinciple) ?? 0.0}
                      </TableCell>
                      <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                        {formattedAmount(
                          row.OriginalPrinciple - row.PrincipalAmount
                        )?? 0.0}
                      </TableCell>
                      <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                        {formattedAmount(row.PrincipalAmount) ?? 0.0}
                      </TableCell>
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          color: row.IsPrinciplePaid === true ? "green" : "red",
                        }}
                      >
                        {row.IsPrinciplePaid === true ? "Paid" : "Pending"}
                      </TableCell>
                      <TableCell>{0.0}</TableCell>
                      <TableCell
                        sx={{
                          borderLeft: "1px solid #ddd",
                          borderRight: "1px solid #ddd",
                        }}
                        rowSpan={3}
                      >
                        {formatDate(row.InterestPaidDate)}
                      </TableCell>
                      {/* <TableCell sx={{ borderRight: "1px solid #ddd" }}  rowSpan={3}>{row.arrears}</TableCell> */}
                      <TableCell
                        rowSpan={3}
                        sx={{
                          color: row.IsCleared === true ? "green" : "red",
                        }}
                      >
                        {row.IsCleared === true ? "Paid" : "Pending"}
                      </TableCell>
                    </TableRow>
                    {/* Second row for Interest */}
                    <TableRow
                      key={`interest-${row.id}`}
                      sx={{ borderBottom: "1px solid #ddd" }}
                    >
                      <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                        Interest
                      </TableCell>
                      <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                        {formattedAmount(row.OriginalInterest) ?? 0.0}
                      </TableCell>

                      <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                      {formattedAmount(row.OriginalInterest - (row.InterestAmount ?? 0))}
                      </TableCell>

                      <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                        {(row.InterestAmount) ?? 0.0}
                      </TableCell>
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          color: row.IsInterestPaid === true ? "green" : "red",
                        }}
                      >
                        {row.IsInterestPaid === true ? "Paid" : "Pending"}
                      </TableCell>

                      <TableCell></TableCell>
                    </TableRow>
                    {/* Third row for Penalty */}
                    <TableRow
                      key={`penalty-${row.id}`}
                      sx={{
                        borderBottom: "1px solid #ddd",
                        borderRight: "1px solid #ddd",
                      }}
                    >
                      <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                        Penalty
                      </TableCell>
                      <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                        {formattedAmount(row.OriginalPenalty)?? 0.0}
                      </TableCell>
                      <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                      {formattedAmount(row.OriginalPenalty - (row.PenaltyAmount ?? 0))}
                      </TableCell>
                      <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                        {(row.PenaltyAmount) ?? 0.0}
                      </TableCell>
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          color:
                            (row.IsPenaltyPaid || row.PenaltyAmount === 0) ===
                            true
                              ? "green"
                              : "red",
                        }}
                      >
                        { (row.IsPenaltyPaid || row.PenaltyAmount === 0) === true ? "Paid" : "Pending"}
                      </TableCell>

                      <TableCell></TableCell>
                    </TableRow>
                  </>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      )}
    </Container>
  );
};

export default GroupLoanSchedule;
